import * as React from "react";

const WhiteboardIcon = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 3h18v12H3V3zm1.5 1.5v9h15v-9h-15z"
      fill={props.fillcolor || "#ffffff"}
      stroke={props.fillcolor || "#ffffff"}
      strokeWidth={0.5}
    />
    <path
      d="M6 6h12v1.5H6V6zm0 3h12v1.5H6V9zm0 3h8v1.5H6V12z"
      fill={props.fillcolor || "#ffffff"}
    />
    <path
      d="M16 18l1.5-1.5L19 18l-1.5 1.5L16 18zm-1 2h4v1.5h-4V20z"
      fill={props.fillcolor || "#ffffff"}
    />
  </svg>
);

export default WhiteboardIcon;
